export const resultsData = [
  { Ion: 'Calcium', chemicalName: 'Ca++', braine: 4981.872399056568, raw: 450 },
  { Ion: 'Magnesium', chemicalName: 'Mg++', braine: 498.7915774250111, raw: 125 },
  { Ion: 'Sodium', chemicalName: 'Na+', braine: 2259.904946703627, raw: 0 },
  { Ion: 'Potassium', chemicalName: 'K+', braine: 48.492220114599846, raw: 0 },
  { Ion: 'Iron', chemicalName: 'Fe++', braine: 4.981014988680816, raw: 0 },
  { Ion: 'Manganese', chemicalName: 'Mn++', braine: 0, raw: 0 },
  { Ion: 'Barium', chemicalName: 'Ba++', braine: 0.04981622830345316, raw: 0 },
  { Ion: 'Strontium', chemicalName: 'Sr++', braine: 0.49813182170564346, raw: 0 },
  { Ion: 'Aluminium', chemicalName: 'Al+', braine: 0, raw: 0 },
  { Ion: 'Ammonia - N', chemicalName: 'NH4+', braine: 2.447244874125541, raw: 0 },
  { Ion: 'Chloride', chemicalName: 'Cl-', braine: 11450.756738868518, raw: 0 },
  { Ion: 'Sulphate', chemicalName: 'SO4--', braine: 2493.984002699007, raw: 0 },
  { Ion: 'Bicarbonate', chemicalName: 'HCO3-', braine: 825.7011566438392, raw: 500 },
  { Ion: 'Nitrate', chemicalName: 'NO3-', braine: 4.884618634618728, raw: 0 },
  { Ion: 'Fluoride', chemicalName: 'F-', braine: 0.48818826544696003, raw: 0 },
  { Ion: 'Silica', chemicalName: 'SiO2', braine: 247.06273756181258, raw: 350 },
  { Ion: 'Ortho-Phosphate', chemicalName: 'PO4---', braine: 24.47244874125541, raw: 0 },
  { Ion: 'TDS', chemicalName: 'tds', braine: 23007.768056444904, raw: 1425 },
  { Ion: 'CO2', chemicalName: 'CO2', braine: 8.923834588245624, raw: 2586.93 },
  { Ion: 'pH', chemicalName: 'ph', braine: 8.19393586991571, raw: 5.5 },
  { Ion: 'CCPP', chemicalName: 'CCPP', braine: 569.5843851704133, raw: -426.63 },
  { Ion: 'S&DI', chemicalName: 'S&DI', braine: 2.417084740631079, raw: -1 },
  { Ion: 'LSI', chemicalName: 'LSI', braine: 2.417084740631079, raw: -1 },
  { Ion: 'IonicStrength', chemicalName: 'Ionic Strength', braine: 0.5707341136453986, raw: 0.04 },
];
export const calculatedResultsData = [
  { Ion: 'Calcium Carbonate', Saturation: 3.31, Limit: 2.7, '% of Max': '-' },
  { Ion: '-', Saturation: 'Saturation', Limit: '-', '% of Max': '% of Max' },
  { Ion: 'Calcium Sulphate', Saturation: 0.0, '% of Max': 3.8, Limit: 0 },
  { Ion: 'Barium Sulphate', Saturation: 0.0, '% of Max': 115.0, Limit: 0 },
  { Ion: 'Strontium Sulphate', Saturation: 0.0, '% of Max': 31.5, Limit: 0 },
  { Ion: 'Calcium Fluoride', Saturation: 0.0, '% of Max': 11700.0, Limit: 0 },
  { Ion: 'Calcium Phosphate', Saturation: 0.0, '% of Max': 12.0, Limit: 0 },
  { Ion: '-', Saturation: 'Brine Conc', '% of Max': '% of Max', Limit: 'Limit' },
  { Ion: 'Iron', Saturation: 0.0, Limit: 0.3, '% of Max': 0.0 },
  { Ion: 'Manganese', Saturation: 0.0, Limit: 0.1, '% of Max': 0.0 },
  { Ion: 'Aluminum', Saturation: 0.0, Limit: 0.1, '% of Max': 0.0 },
  { Ion: 'Silica', Saturation: 17500.0, Limit: 350.0, '% of Max': 5000.0 },
];

export default resultsData;
